<template>
  <main>
    <div class="add-price">
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template v-slot:left-element>
              <h3>{{ $t("title.addPrice") }}</h3>
            </template>

            <template v-slot:right-element>
              <router-link
                :to="{
                  name: 'DetailsService',
                  params: { id: this.referenceId },
                }"
                class="btn btn-outline-primary button"
                :disabled="loading"
              >
                <i class="arrow left"></i>
                {{ $t("button.retour") }}
              </router-link>
            </template>
          </TopTemplate>
          <div v-if="is_created" class="alert alert-success" role="alert">
            {{ $t("info.addPrice") }}
          </div>
          <div class="ajout-container message-add">
            <form novalidate @submit.prevent="onSubmitCreatePriceService">
              <div class="row">
                <div class="col-md-12 p-3" ref="simpleselect">
                  <div class="ajout-container__simple">
                    <label>{{ $t("service.form.name") }}<sup>*</sup></label>
                    <input
                      v-model="nameService"
                      type="text"
                      :reduce="(option) => option.id"
                      class="form-control p-2"
                      disabled
                    />
                    <span class="invalid-feedback"> </span>
                  </div>
                </div>

                <br />
                <div class="col-md-6 p-3">
                  <div class="ajout-container__multiple">
                    <div class="ajout-container__simple">
                      <label>{{ $t("service.form.date") }}</label>
                      <Datepicker
                        autoApply
                        :enableTimePicker="false"
                        v-model="addPrixService.date_start"
                        locale="fr"
                        :format="format_date_v1"
                        @update:modelValue="formatByDate"
                        @input="handleInput($event)"
                        :min-date="new Date()"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6 p-3">
                  <div class="ajout-container__simple">
                    <label>{{ $t("service.form.montant") }}<sup>*</sup></label>
                    <input
                      v-model="addPrixService.price"
                      type="number"
                      :reduce="(option) => option.id"
                      class="form-control p-2"
                      :class="
                        v$.addPrixService.price.$error ? 'is-invalid' : ''
                      "
                      @input="handlePrice($event)"
                    />
                    <span class="text-danger"> {{ messageErrorPrix }}</span>

                    <span
                      class="invalid-feedback"
                      v-if="v$.addPrixService.price.$error"
                    >
                      {{ v$.addPrixService.price.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-12 button-envoyer text-right">
                  <button
                    type="submit"
                    class="btn button btn-primary"
                    :disabled="loading"
                  >
                    <i class="icon-Check"></i>
                    {{ $t("button.confirm") }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import Form from "../../core/Form";
import useValidate from "@vuelidate/core";
import ServicesService from "../../services/services.service";
import { required, maxLength, helpers, numeric } from "@vuelidate/validators";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import _ from "lodash";
import { ref } from "vue";
export default {
  name: "AddPrix",
  components: {
    TopTemplate,
    Datepicker,
  },
  data() {
    return {
      v$: useValidate(),
      addPrixService: new Form({
        price: "",
        date_start: "",
      }),
      nameService: "",
      referenceId: null,
      messageErrorPrix: null,
      reference: {},
      is_created: false,
      loading: false,
    };
  },
  created() {
    this.referenceId = this.$route.params.id;
    this.getDetails();
  },
  mounted() {},
  validations() {
    return {
      addPrixService: {
        date_start: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
        },
        price: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
          numeric: helpers.withMessage(this.$t("validation.numeric"), numeric),
          // maxLength: maxLength(this.requiredDescriptionLength),
        },
      },
    };
  },
  methods: {
    format_date_v1(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },

    handlePrice() {
      if (
        this.addPrixService.price != null &&
        this.reference.last_price != null
      ) {
        if (this.addPrixService.price === this.reference.last_price) {
          this.messageErrorPrix = "Ce montant existe déjà";
        } else {
          this.messageErrorPrix = null;
        }
      }
    },
    getDetails() {
      ServicesService.getPrice(this.referenceId)
        .then((response) => {
          this.reference = response.data.data;
          this.nameService = this.reference.name;
        })
        .catch((error) => {});
    },
    onSubmitCreatePriceService() {
      this.v$.$validate();

      if (!this.v$.$error) {
        const data = {
          date_start: this.addPrixService.date_start,
          price: this.addPrixService.price,
        };

        ServicesService.createPrice(data, this.referenceId)
          .then((response) => {
            this.is_created = true;
            this.loading = false;
            this.scrollToTop();
            this.$router.push({
              name: "DetailsService",
              params: { id: this.referenceId },
            });
          })
          .catch((error) => {
            this.is_created = false;
            this.loading = false;
            this.scrollToTop();
          });
      }
    },
    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },
    formatByDate: _.debounce(function () {
      if (this.addPrixService.date_start != null) {
        this.addPrixService.date_start = this.dateTime(
          this.addPrixService.date_start
        );
      }
    }, 200),
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },

  setup() {
    // In case of a range picker, you'll receive [Date, Date]
    const format = (due_date) => {
      const day = due_date.getDate();
      const month = due_date.getMonth() + 1;
      const year = due_date.getFullYear();
      if (day <= 9) {
        return `0${day}/${month}/${year}`;
      } else if (day > 9) {
        return `${day}/${month}/${year}`;
      }
      if (month <= 9) {
        return `${day}/0${month}/${year}`;
      } else {
        return `${day}/${month}/${year}`;
      }
    };
    const flow = ref(["year", "calendar"]);
    return {
      format,
      flow,
    };
  },
};
</script>